import * as React from "react";
const SvgComment20Px = (props) =>
  React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 18,
        height: 18,
        fill: "black",
        viewBox: "0 0 18 18"
      },
      props
    ),
    React.createElement("path", {
      fill: "current",
      fillRule: "evenodd",
      d: "M0 0h18v13h-7.65L4 18.08V13H0V0Zm2 2v9h4v2.92L9.65 11H16V2H2Z",
      clipRule: "evenodd"
    })
  );
export default SvgComment20Px;
